/* eslint-disable */
import { useMemo, useState, useEffect } from "react";
import ThemeSwitcher from "../components/ThemeSwitcher";
import { getDashboard } from "../store/slices/auth";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import UploadRoster from "./UploadRoster";
export const bodyClass = "bg-slate-950 text-slate-100 min-h-screen flex flex-col font-sans selection:bg-rose-600 selection:text-white";


function EmergencySosMarkup({
  booths,
  boothsLoading,
  boothsError,
  sosAlerts,
  sosLoading,
  sosError,
  onRefreshSos,
  onResolveSos,
  onCancelSos,
  resolvingId,
  cancellingId,
  // user,
  handleLogout,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("ALL");
  const [selectedCircle, setSelectedCircle] = useState("ALL");
  const [selectedStatus, setSelectedStatus] = useState("ALL");
  const [viewMode, setViewMode] = useState("GRID");
  const [uploadOpen, setUploadOpen] = useState(false);
  const handleRosterUpload = async ({
    type,
    csvText,
    headers,
    rows,
    replaceExisting,
    fileName,
  }) => {
    console.log("Import type:", type);
    console.log("CSV headers:", headers);
    console.log("CSV records:", rows);
    console.log("Replace existing:", replaceExisting);

    // Call the relevant page-specific API here.
    // Return false or throw an error if the API fails.

    return {
      success: true,
      message: `${rows.length} records processed successfully.`,
    };
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    user,
    dashboard,
    dashboardLoading,
    dashboardError
  } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getDashboard());
  }, [dispatch]);

  const getId = (value) => {
    if (!value) return "";
    return typeof value === "object"
      ? String(value._id || "")
      : String(value);
  };

  const getDisplayName = (value) => {
    if (!value) return "";
    return typeof value === "object"
      ? value.name || value.subDivisionId || value.circleId || ""
      : String(value);
  };
  // Get unique Sub-Division IDs from SOS records
  const subDivisionOptions = useMemo(() => {
    const values = sosAlerts
      .map((sos) => ({
        id: getId(sos.subDivisionId),
        name: sos.subDivisionName || getDisplayName(sos.subDivisionId),
      }))
      .filter((item) => item.id);

    return [...new Map(values.map((item) => [item.id, item])).values()];
  }, [sosAlerts]);

  const circleOptions = useMemo(() => {
    const values = sosAlerts
      .map((sos) => ({
        id: getId(sos.circleId),
        name: sos.circleName || getDisplayName(sos.circleId),
      }))
      .filter((item) => item.id);

    return [...new Map(values.map((item) => [item.id, item])).values()];
  }, [sosAlerts]);


  // Apply all filters
  const filteredSosAlerts = useMemo(() => {
    return sosAlerts.filter((sos) => {
      const status = String(sos.status || "ACTIVE").toUpperCase();

      const matchesSubDivision =
        selectedSubDivision === "ALL" ||
        getId(sos.subDivisionId) === selectedSubDivision

      const matchesCircle =
        selectedCircle === "ALL" ||
        getId(sos.circleId) === selectedCircle

      let matchesStatus = true;

      if (selectedStatus === "ACTIVE_EMERGENCY") {
        matchesStatus = status === "ACTIVE";
      } else if (selectedStatus === "RESOLVED") {
        matchesStatus = status === "RESOLVED";
      } else if (selectedStatus === "CANCELLED") {
        matchesStatus = status === "CANCELLED";
      } else if (selectedStatus === "STOPPED") {
        matchesStatus = status === "STOPPED";
      }

      const search = searchTerm.trim().toLowerCase();

      const searchableText = [
        sos.officerName,
        sos.officerId,
        sos.phone,
        sos.boothName,
        sos.boothCode,
        sos.stationName,
        sos.reason,
        sos.category,
        sos.designation,
        sos.alertId,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      const matchesSearch =
        !search || searchableText.includes(search);

      return (
        matchesSubDivision &&
        matchesCircle &&
        matchesStatus &&
        matchesSearch
      );
    });
  }, [
    sosAlerts,
    selectedSubDivision,
    selectedCircle,
    selectedStatus,
    searchTerm,
  ]);

  const activeSosCount = sosAlerts.filter(
    (sos) => String(sos.status).toUpperCase() === "ACTIVE"
  ).length;
  const getOfficer = (sos) => {
    if (sos.officerId && typeof sos.officerId === "object") {
      return sos.officerId;
    }

    if (sos.officer && typeof sos.officer === "object") {
      return sos.officer;
    }

    if (sos.user && typeof sos.user === "object") {
      return sos.user;
    }

    return {};
  };

  const getBooth = (sos) => {
    if (sos.boothId && typeof sos.boothId === "object") {
      return sos.boothId;
    }

    if (sos.booth && typeof sos.booth === "object") {
      return sos.booth;
    }

    return {};
  };
  const getRef = (value) => {
    if (!value) return {};
    return typeof value === "object" ? value : {};
  };

  const getTimeAgo = (date) => {
    if (!date) return "Time unavailable";

    const diff = Math.max(0, Date.now() - new Date(date).getTime());
    const minutes = Math.floor(diff / 60000);

    if (minutes < 1) return "Just now";
    if (minutes < 60) return `Clicked ${minutes} min${minutes > 1 ? "s" : ""} ago`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `Clicked ${hours} hr${hours > 1 ? "s" : ""} ago`;

    return `Clicked ${Math.floor(hours / 24)} days ago`;
  };

  const getTime = (date) => {
    if (!date) return "--:--";
    return new Date(date).toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const openSosModal = (modalId, sos) => {
    const modal = document.getElementById(modalId);
    if (!modal) return;

    const id = sos?._id || sos?.id || "";

    const hiddenInput = modal.querySelector('input[type="hidden"]');
    if (hiddenInput) hiddenInput.value = id;

    const summary = modal.querySelector(
      "#dispatch-incident-summary, #pass-on-incident-summary"
    );

    if (summary) {
      summary.textContent =
        `${sos?.alertId || id} | ${sos?.officerName || "Officer"} | ${sos?.reason || "Emergency assistance requested"}`;
    }

    modal.classList.remove("hidden");
    modal.style.display = "flex";
  };

  const activeSosAlerts = sosAlerts.filter(
    (sos) =>
      !["RESOLVED", "CLOSED"].includes(
        String(sos.status || "ACTIVE").toUpperCase()
      )
  );
  return (
    <>
      {/* TOP BRANDING & NAVIGATION HEADER */}
      <header className="bg-slate-900 border-b border-slate-800 px-4 py-2 flex items-center justify-between shrink-0 shadow-md h-16 relative z-30">
        {/* 1. OFFICIAL IDENTITY & BRANDING */}
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-tr from-blue-700 via-indigo-600 to-blue-500 flex items-center justify-center text-white shadow-lg shadow-blue-900/50 text-xl font-black shrink-0 border border-blue-400/30">
            🇮🇳
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h1 className="text-sm font-black tracking-tight text-white flex items-center gap-2 uppercase">
                Nellore Police

              </h1>
            </div>

          </div>
        </div>
        {/* 2. ICONS-WISE PORTAL NAVIGATION BAR (Proper Website Style) */}
        <nav className="hidden lg:flex items-center bg-slate-950 p-1 rounded-xl border border-slate-800 text-xs font-semibold shadow-inner">
          <a href="/admin" className="px-3 py-1.5 text-slate-300 hover:text-white hover:bg-slate-900 rounded-lg transition flex items-center gap-1.5">
            <span>
              🗺️
            </span>
            <span>
              Live Map
            </span>
          </a>
          <span className="px-3 py-1.5 bg-blue-600 text-white rounded-lg font-bold shadow flex items-center gap-1.5 cursor-default">
            <span>
              🚨
            </span>
            <span>
              Incident Grid
            </span>
          </span>


        </nav>
        {/* 3. ACTIONS, TOOLS DROPDOWN LIST, THEME & USER PROFILE */}
        <div className="flex items-center gap-2">
          {/* Register Officer Primary Quick Action */}

          {/* Upload Primary Quick Action */}
          <button onClick={() => setUploadOpen(true)} className="px-3 py-1.5 bg-indigo-600 hover:bg-indigo-500 text-white text-xs font-bold rounded-lg shadow flex items-center gap-1.5 transition">
            <span>
              📤
            </span>
            {' '}
            <span className="hidden sm:inline">
              Upload
            </span>
            {' '}Roster
          </button>
          {/* Operations & Tools Dropdown (Proper List-Wise View) */}
          <div className="relative inline-block text-left" id="header-tools-dropdown-container">


          </div>

          <ThemeSwitcher className="mr-0.5" labelClass="hidden 2xl:inline" />
          <div className="h-6 w-px bg-slate-800 mx-0.5"></div>
          {/* Authenticated Commander Profile & Logout */}
          <div className="flex items-center gap-2 pl-1">
            <div id="header-commander-insignia" className="w-8 h-8 rounded-lg flex items-center justify-center text-xs font-black shadow border border-yellow-400/40 shrink-0" style={{ background: "#172554", color: "#fef08a" }}>
              🦁
            </div>
            <div className="hidden sm:block text-right">
              <div
                id="header-commander-name"
                className="text-xs font-black text-white leading-tight truncate max-w-[130px]"
              >
                {user?.displayName || user?.name || user?.username || "Admin"}
              </div>

              <div
                id="header-commander-scope"
                className="text-[10px] text-amber-300 font-bold leading-tight truncate max-w-[160px]"
              >
                👑 {user?.designation || user?.role || "Administrator"}
              </div>
            </div>
            <button
              type="button"
              onClick={handleLogout}
              title="Logout"
              className="w-8 h-8 rounded-lg bg-slate-800 hover:bg-red-900/40 text-slate-300 hover:text-red-300 border border-slate-700 flex items-center justify-center text-sm transition cursor-pointer"
            >
              🚪
            </button>
          </div>
        </div>
      </header>
      {/* TOP KPI METRIC STRIP (CLICK ANY CARD TO OPEN IN SEPARATE GRID VIEW) */}
      <div className="bg-slate-900/90 border-b border-slate-800/80 px-4 py-2 shrink-0 grid grid-cols-10 gap-2 text-xs">

        {/* Total Sub Divisions */}
        <div
          onClick={() => navigate("/sub-divisions")}
          className="cursor-pointer bg-slate-800/60 hover:bg-slate-800 rounded-lg p-2 border border-slate-700/60 hover:border-purple-400 transition flex items-center justify-between"
        >
          <div>
            <div className="text-[10px] text-purple-400 uppercase font-bold tracking-wider">
              Sub Divisions
            </div>
            <div className="text-base font-black text-purple-300">
              {dashboardLoading ? "..." : dashboard?.totalSubDivisions ?? 0}
            </div>
          </div>
          <span className="text-xl text-purple-400 opacity-50">🏢</span>
        </div>

        {/* Total Circles */}
        <div
          onClick={() => navigate("/circles")}
          className="cursor-pointer bg-slate-800/60 hover:bg-slate-800 rounded-lg p-2 border border-slate-700/60 hover:border-sky-400 transition flex items-center justify-between"
        >
          <div>
            <div className="text-[10px] text-sky-400 uppercase font-bold tracking-wider">
              Total Circles
            </div>
            <div className="text-base font-black text-sky-300">
              {dashboardLoading ? "..." : dashboard?.totalCircles ?? 0}
            </div>
          </div>
          <span className="text-xl text-sky-400 opacity-50">⭕</span>
        </div>

        {/* Total Police Stations */}
        <div
          onClick={() => navigate("/stations")}
          className="cursor-pointer bg-slate-800/60 hover:bg-slate-800 rounded-lg p-2 border border-slate-700/60 hover:border-teal-400 transition flex items-center justify-between"
        >
          <div>
            <div className="text-[10px] text-teal-400 uppercase font-bold tracking-wider">
              Police Stations
            </div>
            <div className="text-base font-black text-teal-300">
              {dashboardLoading ? "..." : dashboard?.totalStations ?? 0}
            </div>
          </div>
          <span className="text-xl text-teal-400 opacity-50">🚔</span>
        </div>
        <div onClick={() => navigate("/booths")}
          className="cursor-pointer bg-slate-800/60 hover:bg-slate-800 rounded-lg p-2 border border-slate-700/60 hover:border-blue-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-slate-400 uppercase font-bold tracking-wider">
              Total Booths
            </div>
            <div id="stat-total-booths" className="text-base font-black text-white">
              {dashboardLoading ? "..." : dashboard?.totalPollingStations ?? 0}
            </div>
          </div>
          <span className="text-xl opacity-40">
            🗳️
          </span>
        </div>
        <div onClick={() => navigate("/officers")} className="cursor-pointer bg-slate-800/60 hover:bg-slate-800 rounded-lg p-2 border border-slate-700/60 hover:border-indigo-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-indigo-400 uppercase font-bold tracking-wider">
              Total Men
            </div>
            <div id="stat-total-staff" className="text-base font-black text-indigo-300">
              {dashboardLoading ? "..." : dashboard?.totalOfficers ?? 0}
            </div>
          </div>
          <span className="text-xl text-indigo-400 opacity-50">
            👮
          </span>
        </div>
        <div onClick={() => navigate("/booths")} className="cursor-pointer bg-rose-950/40 hover:bg-rose-900/40 rounded-lg p-2 border border-rose-600/40 hover:border-rose-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-rose-400 uppercase font-bold tracking-wider">
              Hyper Sensitive
            </div>
            <div id="stat-hyper-sensitive" className="text-base font-black text-rose-400">
              {dashboardLoading ? "..." : dashboard?.hyperSensitiveBooths ?? 0}
            </div>
          </div>
          <span className="text-xl text-rose-400">
            🔥
          </span>
        </div>
        <div onClick={() => navigate("/booths")} className="cursor-pointer bg-amber-950/30 hover:bg-amber-900/40 rounded-lg p-2 border border-amber-600/40 hover:border-amber-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-amber-400 uppercase font-bold tracking-wider">
              Sensitive
            </div>
            <div id="stat-hyper-sensitive" className="text-base font-black text-rose-400">
              {dashboardLoading ? "..." : dashboard?.hyperSensitiveBooths ?? 0}
            </div>
          </div>
          <span className="text-xl text-amber-400">
            ⚠️
          </span>
        </div>

        <div onClick={() => navigate("/officers")} title="View Verified On-Site Personnel in Grid View" className="cursor-pointer bg-emerald-950/20 hover:bg-emerald-900/30 rounded-lg p-2 border border-emerald-600/30 hover:border-emerald-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-emerald-400 uppercase font-bold tracking-wider">
              On-Site (≤75m)
            </div>
            <div id="stat-onsite" className="text-base font-black text-emerald-400">
              {dashboardLoading ? "..." : dashboard?.atPollingStation ?? 0}
            </div>
          </div>
          <span className="text-xl text-emerald-500 opacity-60">
            ✓
          </span>
        </div>
        <div id="card-kpi-absent" onClick={() => navigate("/officers")} className="cursor-pointer bg-rose-950/30 hover:bg-rose-900/40 rounded-lg p-2 border border-rose-500/50 hover:border-rose-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-rose-400 uppercase font-bold tracking-wider">
              Not Attended
            </div>
            <div id="stat-non-attended" className="text-base font-black text-rose-400">
              {dashboardLoading ? "..." : dashboard?.absentAttendance ?? 0}
            </div>
          </div>
          <span className="text-xl text-rose-500">
            ✕
          </span>
        </div>
        <div id="card-kpi-sos" onClick={() => navigate("/emergency-sos")} title="Click to View Active Emergency SOS Distress Incidents Directly" className="cursor-pointer bg-red-950/30 hover:bg-red-900/50 rounded-lg p-2 border border-red-500/50 hover:border-red-400 transition flex items-center justify-between animate-sos-strobe">
          <div>
            <div className="text-[10px] text-red-400 uppercase font-bold tracking-wider">
              Emergency SOS
            </div>
            <div id="stat-sos" className="text-base font-black text-red-500">
              {dashboardLoading ? "..." : dashboard?.activeSOS ?? 0}
            </div>
          </div>
          <span className="text-xl text-red-500">
            🚨
          </span>
        </div>
      </div >
      {/* SEARCH, HIERARCHY FILTERS & VIEW MODE CONTROLS */}
      <section className="bg-slate-950 border-b border-slate-800 px-4 py-2.5">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3">
          {/* Search Input */}
          <div className="relative w-full md:w-72">

          </div>

          {/* Hierarchy Filter Dropdowns */}
          <div className="flex flex-wrap items-center gap-2 w-full md:w-auto text-xs">
            <select
              value={selectedSubDivision}
              onChange={(e) => setSelectedSubDivision(e.target.value)}
              className="bg-slate-900 border border-slate-700 text-slate-200 rounded-lg px-2.5 py-2 text-xs"
            >
              <option value="ALL">All Sub-Divisions</option>
              {subDivisionOptions.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>

            <select
              value={selectedCircle}
              onChange={(e) => setSelectedCircle(e.target.value)}
              className="bg-slate-900 border border-slate-700 text-slate-200 rounded-lg px-2.5 py-2 text-xs"
            >
              <option value="ALL">All Circles</option>
              {circleOptions.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>

            <select
              id="grid-filter-status"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
              className="bg-slate-900 border border-slate-700 text-slate-200 rounded-lg px-2.5 py-1.5 focus:outline-none focus:border-indigo-500"
            >
              <option value="ALL">All Statuses</option>
              <option value="ACTIVE_EMERGENCY">Active Emergencies Only</option>
              <option value="RESOLVED">Resolved Incidents</option>
              <option value="CANCELLED">Cancelled Incidents</option>
              <option value="STOPPED">Stopped Incidents</option>
            </select>
            {/* View Mode: Grid Cards vs Table View */}
            <div className="flex items-center bg-slate-900 p-0.5 rounded-lg border border-slate-700">
              <div className="flex items-center bg-slate-900 p-0.5 rounded-lg border border-slate-700">
                <button
                  type="button"
                  onClick={() => setViewMode("GRID")}
                  className={`px-2.5 py-1 rounded font-bold transition flex items-center gap-1 ${viewMode === "GRID"
                    ? "bg-indigo-600 text-white"
                    : "text-slate-300 hover:text-white"
                    }`}
                >
                  🔲 Grid
                </button>

                <button
                  type="button"
                  onClick={() => setViewMode("TABLE")}
                  className={`px-2.5 py-1 rounded font-bold transition flex items-center gap-1 ${viewMode === "TABLE"
                    ? "bg-indigo-600 text-white"
                    : "text-slate-300 hover:text-white"
                    }`}
                >
                  📋 Table
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CATEGORY BANNER WITH SUMMARY */}
      <div className="bg-slate-900/60 border-b border-slate-800/80 px-4 py-2 shrink-0">
        <div className="max-w-7xl mx-auto flex items-center justify-between text-xs">
          <div className="flex items-center gap-2">
            <span id="current-category-icon" className="text-base">
              🚨
            </span>
            <h2 id="current-category-title" className="font-bold text-white text-sm">
              Active Emergency SOS Incidents & Distress Beacons
            </h2>
            <span
              id="current-category-count-badge"
              className="px-2 py-0.5 rounded-full text-[10px] font-black bg-rose-600 text-white"
            >
              {filteredSosAlerts.length} Incidents
            </span>
          </div>
          <div className="text-[11px] text-slate-400">
            Showing{' '}
            <span id="filtered-items-count" className="font-bold text-white">
              {filteredSosAlerts.length}
            </span>
            {' '}matching entries •{' '}
            <span className="text-emerald-400">
              Direct Actions Available
            </span>
          </div>
        </div>
      </div>
      {/* MAIN CONTENT: DYNAMIC GRID VIEW CONTAINER */}
      <main className="flex-1 overflow-y-auto p-4 sm:p-6 bg-slate-950">
        <div className="max-w-7xl mx-auto">

          <section className={`mb-5 ${viewMode === "GRID" ? "" : "hidden"}`}>

            <div className="flex items-center justify-between mb-4">
              <div>
                <h2 className="text-sm font-black text-white">
                  🚨 SOS Incidents
                </h2>

                <p className="text-[11px] text-slate-400 mt-1">
                  Live emergency alerts received from officers
                </p>
              </div>

              <div className="flex items-center gap-3">
                <span className="px-3 py-1 rounded-lg bg-red-950 text-red-400 text-xs font-bold">
                  {activeSosCount} Active
                </span>

                <button
                  type="button"
                  onClick={onRefreshSos}
                  disabled={sosLoading}
                  className="px-3 py-1.5 rounded-lg bg-indigo-600 hover:bg-indigo-500 disabled:opacity-50 text-white text-xs font-bold"
                >
                  {sosLoading ? "Refreshing..." : "↻ Refresh"}
                </button>
              </div>
            </div>

            {sosError && (
              <div className="p-3 mb-3 rounded-lg bg-red-950/50 border border-red-800 text-red-300 text-xs">
                {sosError}
              </div>
            )}

            {sosLoading && sosAlerts.length === 0 ? (
              <div className="text-center py-12 text-slate-400 text-xs">
                <div className="animate-spin rounded-full h-7 w-7 border-b-2 border-red-500 mx-auto mb-3" />
                Loading SOS alerts...
              </div>
            ) : filteredSosAlerts.length === 0 ? (
              <div className="text-center py-12 bg-slate-900 border border-slate-800 rounded-2xl">
                <div className="text-4xl mb-3">🛡️</div>

                <h3 className="text-sm font-bold text-white">
                  No Active SOS Incidents
                </h3>

                <p className="text-xs text-slate-500 mt-1">
                  There are currently no unresolved SOS alerts.
                </p>
              </div>
            ) : (

              <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3 items-stretch">
                {filteredSosAlerts.map((sos) => {
                  const officer = getOfficer(sos);
                  const booth = getBooth(sos);

                  const id = sos._id || sos.id;
                  const status = String(sos.status || "ACTIVE").toUpperCase();
                  const isActive = ![
                    "RESOLVED",
                    "CLOSED",
                    "REJECTED",
                    "CANCELLED",
                    "STOPPED",
                  ].includes(status);

                  const isResolving = String(resolvingId) === String(id);
                  const isCancelling = String(cancellingId) === String(id);
                  const station = getRef(sos.stationId || booth.policeStationId);
                  const subDivision = getRef(sos.subDivisionId);
                  const circle = getRef(sos.circleId);

                  const officerName =
                    sos.officerName || sos.staffName ||
                    officer.displayName || officer.name || "Unknown Officer";

                  const officerCode =
                    sos.officerCode || officer.officerId ||
                    (typeof sos.officerId === "string" ? sos.officerId : "") ||
                    officer.badgeNo || "--";

                  const designation =
                    sos.designation || officer.designationName ||
                    officer.designation || "Police Officer";

                  const phone =
                    sos.officerPhone || sos.phone ||
                    officer.phone || officer.mobileNumber || "";

                  const boothName = sos.boothName || booth.name || "Polling Station";
                  const boothCode = sos.boothCode || booth.boothId || booth.code || "--";

                  const stationName =
                    sos.policeStationName || sos.stationName || station.name || "--";

                  const subDivisionName =
                    sos.subDivisionName || subDivision.name || "--";

                  const circleName =
                    sos.circleName || circle.name || "--";

                  const shoName =
                    sos.shoName ||
                    station.shoOfficerId?.displayName ||
                    station.shoOfficerId?.name || "--";

                  const reason =
                    sos.reason || sos.message || sos.description ||
                    "Emergency assistance requested";

                  const severity = String(
                    sos.severity || sos.priority || "HIGH"
                  ).toUpperCase();

                  const createdAt =
                    sos.createdAt || sos.triggeredAt || sos.timestamp;

                  const coordinates = sos.location?.coordinates;

                  const lat =
                    sos.lat ?? sos.latitude ?? sos.location?.lat ??
                    (Array.isArray(coordinates) ? coordinates[1] : null);

                  const lng =
                    sos.lng ?? sos.longitude ?? sos.location?.lng ??
                    (Array.isArray(coordinates) ? coordinates[0] : null);

                  const alertId = sos.alertId || `SOS-${String(id).slice(-8)}`;

                  const initials = officerName
                    .split(" ")
                    .filter(Boolean)
                    .slice(0, 2)
                    .map((word) => word[0])
                    .join("")
                    .toUpperCase();

                  const severityClass =
                    severity === "CRITICAL"
                      ? "bg-red-600 text-white"
                      : severity === "HIGH"
                        ? "bg-orange-500 text-white"
                        : severity === "MEDIUM"
                          ? "bg-yellow-500 text-slate-950"
                          : "bg-blue-600 text-white";

                  const latestMessage =
                    typeof sos.latestMessage === "string"
                      ? sos.latestMessage
                      : sos.latestMessage?.message;

                  return (
                    <article
                      key={id}
                      className={`w-full min-w-0 h-full rounded-2xl border-2 ${isActive
                          ? "border-red-500"
                          : status === "RESOLVED"
                            ? "border-emerald-600"
                            : status === "STOPPED"
                              ? "border-slate-500"
                              : "border-amber-600"
                        } bg-[#131e39] p-3 shadow-lg flex flex-col`}
                    >
                      {/* HEADER */}
                      <div className="flex items-start justify-between gap-2 pb-3 border-b border-slate-700">
                        <div className="min-w-0 flex-1">
                          <span
                            className={`inline-block px-2 py-1 rounded-full text-[10px] font-extrabold tracking-wide ${isActive
                              ? "bg-red-800 text-red-100"
                              : "bg-emerald-800 text-emerald-100"
                              }`}
                          >
                            {status === "STOPPED"
                              ? "■ STOPPED SOS"
                              : status === "RESOLVED"
                                ? "✓ RESOLVED SOS"
                                : status === "CANCELLED"
                                  ? "✕ CANCELLED SOS"
                                  : isActive
                                    ? "🚨 ACTIVE SOS"
                                    : status}
                          </span>

                          <p className="font-mono text-[10px] text-slate-400 mt-1 break-all">
                            {alertId}
                          </p>
                        </div>

                        <div className="text-right shrink-0">
                          <p className="text-xs font-bold text-red-300">
                            🕒 {getTime(createdAt)}
                          </p>
                          <p className="text-[10px] text-slate-500 mt-1">
                            {getTimeAgo(createdAt)}
                          </p>
                        </div>
                      </div>

                      {/* OFFICER DETAILS */}
                      <div className="flex items-center gap-2.5 py-3">
                        <div className="w-12 h-12 shrink-0 rounded-xl bg-amber-700 flex flex-col items-center justify-center text-white">
                          <span className="text-base">🚨</span>
                          <span className="text-[10px] font-black">
                            {initials || "HC"}
                          </span>
                        </div>

                        <div className="min-w-0 flex-1">
                          <h3 className="text-sm font-extrabold text-white leading-tight break-words">
                            {officerName}
                          </h3>

                          <p className="text-[10px] text-indigo-300 mt-1">
                            {officerCode}
                          </p>

                          <p className="text-[11px] text-slate-400 mt-0.5">
                            {designation}
                          </p>

                          <p className="text-[10px] text-slate-400 mt-1 break-all">
                            📱 {phone || "Phone unavailable"}
                          </p>
                        </div>
                      </div>

                      {/* CALL / WHATSAPP */}
                      {phone && (
                        <div className="flex gap-2 mb-3">
                          <a
                            href={`tel:${phone}`}
                            className="flex-1 text-center rounded-lg bg-blue-600 hover:bg-blue-500 px-2 py-1.5 text-white text-[11px] font-bold transition"
                          >
                            📞 Call
                          </a>

                          <a
                            href={`https://wa.me/${String(phone).replace(/\D/g, "").replace(/^0/, "")}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex-1 text-center rounded-lg bg-emerald-600 hover:bg-emerald-500 px-2 py-1.5 text-white text-[11px] font-bold transition"
                          >
                            WhatsApp
                          </a>
                        </div>
                      )}

                      {/* BOOTH / STATION INFORMATION */}
                      <div className="rounded-xl border border-[#263c68] bg-[#070e23] p-3 mb-3">
                        <div className="flex items-start justify-between gap-2 mb-2">
                          <p className="text-xs font-bold text-slate-200 leading-relaxed min-w-0 break-words">
                            🏛️ {boothCode} • {boothName}
                          </p>

                          <span className={`shrink-0 px-2 py-1 rounded-md text-[9px] font-extrabold ${severityClass}`}>
                            ⚠ {severity}
                          </span>
                        </div>

                        <div className="space-y-1.5 text-[10px]">
                          <p className="text-slate-400 break-words">
                            PS: <span className="text-slate-200 font-semibold">{stationName}</span>
                          </p>

                          <p className="text-slate-400 break-words">
                            SHO: <span className="text-indigo-300 font-semibold">{shoName}</span>
                          </p>

                          <p className="text-slate-400 break-words">
                            Sub-Div: <span className="text-slate-300">{subDivisionName}</span>
                          </p>

                          <p className="text-slate-400 break-words">
                            CI: <span className="text-slate-300">{circleName}</span>
                          </p>
                        </div>
                      </div>

                      {/* EMERGENCY REASON */}
                      <div className="rounded-xl border border-red-800 bg-[#291827] p-3 mb-3">
                        <div className="flex items-start justify-between gap-2 mb-2">
                          <p className="text-[10px] font-extrabold text-red-400 leading-relaxed">
                            ⚠ EMERGENCY REASON
                          </p>

                          {lat != null && lng != null && (
                            <p className="font-mono text-[9px] text-slate-400 shrink-0">
                              {Number(lat).toFixed(4)}, {Number(lng).toFixed(4)}
                            </p>
                          )}
                        </div>

                        <p className="text-xs font-bold text-white leading-relaxed break-words">
                          {reason}
                        </p>
                      </div>

                      {/* ACTION INFORMATION */}
                      <div className="rounded-lg border border-blue-900 bg-[#0b142b] p-2.5 mb-2">
                        <p className="text-[10px] leading-relaxed">
                          <span className="text-yellow-400 font-bold">⚡ Action: </span>
                          <span className="text-slate-300">
                            {sos.actionDescription ||
                              sos.action ||
                              "Emergency beacon clicked via Police Mobile Duty App"}
                          </span>
                        </p>
                        <p className="text-[9px] text-slate-500 mt-1">
                          {getTimeAgo(createdAt)}
                        </p>
                      </div>

                      {/* LATEST MESSAGE */}
                      {latestMessage && (
                        <div className="rounded-lg border border-indigo-900 bg-[#191d42] p-2.5 mb-3">
                          <p className="text-[10px] text-indigo-200 leading-relaxed">
                            💬 <strong>{officerName}:</strong> {latestMessage}
                          </p>
                        </div>
                      )}

                      {/* ACTION BUTTONS */}
                      <div className="border-t border-slate-700 pt-3 mt-auto">
                        <div className="flex flex-wrap gap-1.5">
                          {isActive && (
                            <div className="flex justify-end gap-2">
                              <button
                                type="button"
                                disabled={isResolving || isCancelling}
                                onClick={() => onResolveSos?.(id)}
                                className="px-3 py-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-500 disabled:opacity-50 text-white text-[10px] font-bold"
                              >
                                {isResolving ? "Resolving..." : "Resolve"}
                              </button>

                              <button
                                type="button"
                                disabled={isResolving || isCancelling}
                                onClick={() => onCancelSos?.(id)}
                                className="px-3 py-1.5 rounded-lg bg-red-600 hover:bg-red-500 disabled:opacity-50 text-white text-[10px] font-bold"
                              >
                                {isCancelling ? "Cancelling..." : "Cancel"}
                              </button>
                            </div>
                          )}

                          {!isActive && (
                            <span className="text-[10px] font-bold text-slate-400">
                              {status}
                            </span>
                          )}

                          {!isActive && (
                            <span className={`rounded-lg px-2.5 py-2 text-[10px] font-bold ${status === "RESOLVED"
                              ? "bg-emerald-950 text-emerald-300"
                              : status === "CANCELLED"
                                ? "bg-red-950 text-red-300"
                                : "bg-slate-800 text-slate-300"
                              }`}>
                              {status === "RESOLVED"
                                ? "✓ Resolved"
                                : status === "CANCELLED"
                                  ? "✕ Cancelled"
                                  : status === "STOPPED"
                                    ? "■ Stopped"
                                    : status}
                            </span>
                          )}

                          {lat != null && lng != null && (
                            <a
                              href={`https://www.google.com/maps?q=${lat},${lng}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="rounded-lg bg-blue-950 hover:bg-blue-900 text-blue-300 px-2.5 py-2 text-[10px] font-bold transition"
                            >
                              🗺 Map
                            </a>
                          )}

                          {/* <button
                            type="button"
                            onClick={() => openSosModal("history-modal", sos)}
                            className="rounded-lg bg-slate-800 hover:bg-slate-700 text-indigo-300 px-2.5 py-2 text-[10px] font-bold transition"
                          >
                            🕒 24h
                          </button> */}

                          {isActive && (
                            <button
                              type="button"
                              disabled={!id || isResolving}
                              onClick={() => onResolveSos?.(id)}
                              title="Resolve SOS"
                              className="rounded-lg bg-emerald-900 hover:bg-emerald-800 disabled:opacity-50 text-emerald-300 px-3 py-2 text-xs font-black transition"
                            >
                              {isResolving ? "..." : "✓"}
                            </button>
                          )}
                          {status === "RESOLVED" && (
                            <span className="rounded-lg bg-emerald-950 text-emerald-300 px-2.5 py-2 text-[10px] font-bold">
                              ✓ Resolved
                            </span>
                          )}
                        </div>
                      </div>
                    </article>
                  );
                })}
              </div>

            )}
          </section>
          {/* 2. TABLE VIEW (Alternative spreadsheet style) */}
          <div
            id="table-view-container"
            className={`overflow-x-auto bg-slate-900 border border-slate-800 rounded-2xl shadow-xl ${viewMode === "TABLE" ? "" : "hidden"
              }`}
          >
            <table className="w-full text-left text-xs text-slate-300">
              <thead className="bg-slate-950 text-slate-400 font-bold uppercase text-[10px] border-b border-slate-800 tracking-wider">
                <tr>
                  <th className="p-3">Ref ID / Status</th>
                  <th className="p-3">Officer Details</th>
                  <th className="p-3">Phone</th>
                  <th className="p-3">Designation</th>
                  <th className="p-3">Police Station</th>
                  <th className="p-3">Booth</th>
                  <th className="p-3">Severity</th>
                  <th className="p-3">Incident / Reason</th>
                  <th className="p-3">Triggered At</th>
                  <th className="p-3">Location</th>
                  <th className="p-3 text-right">Actions</th>
                </tr>
              </thead>

              <tbody className="divide-y divide-slate-800/80">
                {filteredSosAlerts.map((sos) => {
                  const id = sos._id || sos.id;

                  const status = String(sos.status || "ACTIVE").toUpperCase();

                  const isActive = ![
                    "RESOLVED",
                    "CLOSED",
                    "REJECTED",
                    "CANCELLED",
                    "STOPPED",
                  ].includes(status);

                  const isResolving = String(resolvingId) === String(id);
                  const isCancelling = String(cancellingId) === String(id);

                  const lat = sos.lat ?? sos.latitude;
                  const lng = sos.lng ?? sos.longitude;

                  return (
                    <tr key={id} className="hover:bg-slate-800/60 transition">
                      <td className="p-3">
                        <div className="font-bold text-white">
                          {sos.alertId || id}
                        </div>

                        <span
                          className={`inline-block mt-1 px-2 py-1 rounded text-[10px] font-bold ${isActive
                            ? "bg-red-950 text-red-400"
                            : "bg-emerald-950 text-emerald-400"
                            }`}
                        >
                          {sos.status}
                        </span>
                      </td>

                      <td className="p-3">
                        <div className="font-bold text-white">
                          {sos.officerName || "--"}
                        </div>
                        <div className="text-cyan-400 text-[10px]">
                          {sos.officerId || "--"}
                        </div>
                      </td>

                      <td className="p-3">
                        {sos.phone || "--"}
                      </td>

                      <td className="p-3">
                        {sos.designation || "--"}
                      </td>

                      <td className="p-3">
                        {sos.stationName || sos.policeStationName || "--"}
                      </td>

                      <td className="p-3">
                        {sos.boothName || sos.boothCode || "--"}
                      </td>

                      <td className="p-3">
                        <span className="text-amber-400 font-bold">
                          {sos.severity || "--"}
                        </span>
                      </td>

                      <td className="p-3 min-w-[180px]">
                        {sos.reason || "--"}
                      </td>

                      <td className="p-3 whitespace-nowrap">
                        {sos.createdAt
                          ? new Date(sos.createdAt).toLocaleString()
                          : "--"}
                      </td>

                      <td className="p-3 whitespace-nowrap">
                        {lat != null && lng != null ? (
                          <a
                            href={`https://www.google.com/maps?q=${lat},${lng}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-400 hover:text-blue-300 font-bold"
                          >
                            📍 View Map
                          </a>
                        ) : (
                          "--"
                        )}
                      </td>

                      <td className="p-3 text-right whitespace-nowrap">
                        {isActive && (
                          <button
                            type="button"
                            disabled={isResolving}
                            onClick={() => onResolveSos?.(id)}
                            className="px-3 py-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-500 disabled:opacity-50 text-white text-[10px] font-bold"
                          >
                            {isResolving ? "Resolving..." : "Resolve"}
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}

                {filteredSosAlerts.length === 0 && (
                  <tr>
                    <td colSpan={11} className="p-8 text-center text-slate-400">
                      No SOS incidents found matching the selected filters.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {/* Empty State Indicator */}
          <div id="empty-state-card" className="hidden p-12 text-center text-slate-400">
            <div className="text-4xl mb-2">
              🔍
            </div>
            <h3 className="text-base font-bold text-white">
              No items found matching criteria
            </h3>
            <p className="text-xs text-slate-500 mt-1">
              Try resetting the search query or changing the category filter.
            </p>
          </div>
        </div>
      </main>
      {/* ============================================================ */}
      {/* ACTION MODALS */}
      {/* ============================================================ */}
      {/* MODAL 1: DISPATCH TACTICAL FORCE / QRT */}
      <div id="dispatch-force-modal" className="hidden fixed inset-0 z-[99999] bg-black/85 backdrop-blur-md flex items-center justify-center p-4" style={{ zIndex: "99999", display: "none" }}>
        <div className="bg-slate-900 border border-red-500/60 rounded-3xl w-full max-w-lg p-6 shadow-2xl text-slate-200 flex flex-col">
          <div className="flex items-center justify-between pb-3 border-b border-slate-800 mb-4">
            <div className="flex items-center gap-2">
              <span className="text-xl">
                ⚡
              </span>
              <h3 className="text-sm font-black text-white uppercase tracking-tight">
                Dispatch Tactical Striking Force / QRT
              </h3>
            </div>
            <button onClick={(event) => { closeModal('dispatch-force-modal') }} className="text-slate-400 hover:text-white text-2xl font-bold">
              ×
            </button>
          </div>
          <div id="dispatch-incident-summary" className="p-3 bg-red-950/40 rounded-xl border border-red-500/40 text-xs mb-4 space-y-1">
            {/* Injected dynamically */}
          </div>
          <form id="dispatch-force-form" onSubmit={(event) => { handleDispatchForceSubmit(event) }} className="space-y-3.5">
            <input type="hidden" id="dispatch-incident-id" defaultValue="" />
            <div>
              <label className="block text-xs font-semibold text-slate-300 mb-1">
                Select Tactical Formation to Deploy:
              </label>
              <select id="dispatch-unit-select" required className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white">
                {/* Injected with available Striking Forces, Flying Squads, Route Mobiles */}
              </select>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-semibold text-slate-300 mb-1">
                  Estimated Arrival (ETA):
                </label>
                <input type="text" id="dispatch-eta" defaultValue="3 to 5 minutes" className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white" />
              </div>
              <div>
                <label className="block text-xs font-semibold text-slate-300 mb-1">
                  Siren & Equipment Protocol:
                </label>
                <select id="dispatch-protocol" className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white">
                  <option value="ARMED_QRT">
                    Full Riot Gear + Helmets + Batons
                  </option>
                  <option value="TEAR_GAS">
                    Gas Party Tear Smoke Shells
                  </option>
                  <option value="MEDIC">
                    Emergency Medical First Responder
                  </option>
                  <option value="EVM_ESCORT">
                    Armed EVM Vault Escort
                  </option>
                </select>
              </div>
            </div>
            <div>
              <label className="block text-xs font-semibold text-slate-300 mb-1">
                Tactical Dispatch Order Instructions:
              </label>
              <textarea id="dispatch-instructions" rows="2" className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white" placeholder="Move immediately with sirens active. Clear outer perimeter. Report when on scene." />
            </div>
            <div className="flex items-center justify-end gap-2 pt-2 border-t border-slate-800">
              <button type="button" onClick={(event) => { closeModal('dispatch-force-modal') }} className="px-4 py-2 bg-slate-800 text-slate-300 hover:text-white rounded-xl text-xs font-bold transition">
                Cancel
              </button>
              <button type="submit" className="px-5 py-2 bg-red-600 hover:bg-red-500 text-white rounded-xl text-xs font-black shadow-lg shadow-red-900/50 flex items-center gap-1.5 transition">
                <span>
                  ⚡
                </span>
                {' '}CONFIRM FORCE DISPATCH →
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* MODAL 2: PASS ON INFORMATION & ALERT SUPERIORS */}
      <div id="pass-on-modal" className="hidden fixed inset-0 z-[99999] bg-black/85 backdrop-blur-md flex items-center justify-center p-4" style={{ zIndex: "99999", display: "none" }}>
        <div className="bg-slate-900 border border-indigo-500/60 rounded-3xl w-full max-w-lg p-6 shadow-2xl text-slate-200 flex flex-col">
          <div className="flex items-center justify-between pb-3 border-b border-slate-800 mb-4">
            <div className="flex items-center gap-2">
              <span className="text-xl">
                📢
              </span>
              <h3 className="text-sm font-black text-white uppercase tracking-tight">
                Pass On Information & Notify Superiors
              </h3>
            </div>
            <button onClick={(event) => { closeModal('pass-on-modal') }} className="text-slate-400 hover:text-white text-2xl font-bold">
              ×
            </button>
          </div>
          <div id="pass-on-incident-summary" className="p-3 bg-indigo-950/40 rounded-xl border border-indigo-500/40 text-xs mb-4 space-y-1">
            {/* Injected dynamically */}
          </div>
          <form id="pass-on-form" onSubmit={(event) => { handlePassOnSubmit(event) }} className="space-y-3.5">
            <input type="hidden" id="pass-on-incident-id" defaultValue="" />
            <div>
              <label className="block text-xs font-semibold text-slate-300 mb-1.5">
                Select Superior Officers & Wings to Pass On Alert:
              </label>
              <div className="space-y-2 bg-slate-950 p-3 rounded-xl border border-slate-800 text-xs">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" id="pass-role-dsp" defaultChecked className="w-4 h-4 rounded text-indigo-600" />
                  <span>
                    🌟{' '}
                    <strong>
                      Sub-Division Commander (DSP)
                    </strong>
                  </span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" id="pass-role-ci" defaultChecked className="w-4 h-4 rounded text-indigo-600" />
                  <span>
                    🎖️{' '}
                    <strong>
                      Circle Inspector (CI)
                    </strong>
                  </span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" id="pass-role-si" defaultChecked className="w-4 h-4 rounded text-indigo-600" />
                  <span>
                    🚓{' '}
                    <strong>
                      Station House Officer (Sub-Inspector SHO)
                    </strong>
                  </span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" id="pass-role-sp" defaultChecked className="w-4 h-4 rounded text-indigo-600" />
                  <span>
                    🛡️{' '}
                    <strong>
                      SP District Control Room (Admin HQ)
                    </strong>
                  </span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" id="pass-role-route" defaultChecked className="w-4 h-4 rounded text-indigo-600" />
                  <span>
                    🚓{' '}
                    <strong>
                      Nearest Sector Route Mobiles
                    </strong>
                  </span>
                </label>
              </div>
            </div>
            <div>
              <label className="block text-xs font-semibold text-slate-300 mb-1">
                Custom Information Directive / Note to Pass On:
              </label>
              <textarea id="pass-on-note" rows="3" required className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white" placeholder="High priority alert passed to command line. Sub-Inspector to proceed to booth immediately." />
            </div>
            <div className="flex items-center justify-end gap-2 pt-2 border-t border-slate-800">
              <button type="button" onClick={(event) => { closeModal('pass-on-modal') }} className="px-4 py-2 bg-slate-800 text-slate-300 hover:text-white rounded-xl text-xs font-bold transition">
                Cancel
              </button>
              <button type="submit" className="px-5 py-2 bg-indigo-600 hover:bg-indigo-500 text-white rounded-xl text-xs font-black shadow-lg shadow-indigo-900/50 flex items-center gap-1.5 transition">
                <span>
                  📢
                </span>
                {' '}TRANSMIT & BROADCAST ALERT →
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* MODAL 3: TWO-WAY LIVE MESSAGE & REPLY THREAD */}
      <div id="thread-modal" className="hidden fixed inset-0 z-[99999] bg-black/85 backdrop-blur-md flex items-center justify-center p-4" style={{ zIndex: "99999", display: "none" }}>
        <div className="bg-slate-900 border border-slate-700 rounded-3xl w-full max-w-xl p-6 shadow-2xl text-slate-200 flex flex-col max-h-[90vh]">
          <div className="flex items-center justify-between pb-3 border-b border-slate-800 mb-3">
            <div className="flex items-center gap-2">
              <span className="text-xl">
                💬
              </span>
              <div>
                <h3 id="thread-modal-title" className="text-sm font-black text-white">
                  Two-Way Messaging & Reply Center
                </h3>
                <p id="thread-modal-subtitle" className="text-[10px] text-slate-400">
                  Live communication between Admin & Booth Staff
                </p>
              </div>
            </div>
            <button onClick={(event) => { closeModal('thread-modal') }} className="text-slate-400 hover:text-white text-2xl font-bold">
              ×
            </button>
          </div>
          {/* Personnel Quick Info Header */}
          <div id="thread-personnel-header" className="p-2.5 bg-slate-950 rounded-xl border border-slate-800 text-xs mb-3 flex items-center justify-between">
            {/* Injected dynamically */}
          </div>
          {/* Live Chat Messages Bubbles Feed */}
          <div id="thread-messages-box" className="flex-1 overflow-y-auto space-y-2.5 p-3 bg-slate-950/80 rounded-2xl border border-slate-800 min-h-[220px] max-h-[340px]">
            {/* Injected dynamically */}
          </div>
          {/* Quick Canned Message Buttons */}
          <div className="flex flex-wrap gap-1.5 py-2 text-[10px]">
            <button type="button" onClick={(event) => { pasteCannedMessage('Reinforcements dispatched. Maintain iron gate perimeter.') }} className="px-2 py-0.5 rounded bg-slate-800 text-slate-300 hover:bg-slate-700">
              Reinforcements dispatched
            </button>
            <button type="button" onClick={(event) => { pasteCannedMessage('Acknowledge presence and report current booth voter queue.') }} className="px-2 py-0.5 rounded bg-slate-800 text-slate-300 hover:bg-slate-700">
              Report booth status
            </button>
            <button type="button" onClick={(event) => { pasteCannedMessage('Master EVM technician arriving with reserve machine.') }} className="px-2 py-0.5 rounded bg-slate-800 text-slate-300 hover:bg-slate-700">
              EVM tech arriving
            </button>
            <button type="button" onClick={(event) => { pasteCannedMessage('Remain calm. Help is 2 minutes away.') }} className="px-2 py-0.5 rounded bg-slate-800 text-slate-300 hover:bg-slate-700">
              Help 2 mins away
            </button>
          </div>
          {/* Send Reply Input Form */}
          <form id="thread-reply-form" onSubmit={(event) => { handleThreadReplySubmit(event) }} className="flex gap-2 pt-2 border-t border-slate-800">
            <input type="hidden" id="thread-incident-id" defaultValue="" />
            <input type="text" id="thread-reply-input" required placeholder="Type official directive, instructions, or reply..." className="flex-1 bg-slate-950 border border-slate-700 rounded-xl px-3 py-2 text-xs text-white placeholder-slate-400 focus:outline-none focus:border-indigo-500" />
            <button type="submit" className="px-4 py-2 bg-indigo-600 hover:bg-indigo-500 text-white rounded-xl text-xs font-bold transition flex items-center gap-1 shadow">
              <span>
                Send
              </span>
              {' '}→
            </button>
          </form>
        </div>
      </div>
      {/* MODAL 4: 24-HOUR LOCATION HISTORY TRAIL PLAYBACK */}
      <div id="history-modal" className="hidden fixed inset-0 z-[99999] bg-black/85 backdrop-blur-md flex items-center justify-center p-4" style={{ zIndex: "99999", display: "none" }}>
        <div className="bg-slate-900 border border-slate-700 rounded-3xl w-full max-w-4xl p-6 shadow-2xl text-slate-200 flex flex-col max-h-[92vh]">
          <div className="flex items-center justify-between pb-3 border-b border-slate-800 mb-3">
            <div>
              <h3 className="text-base font-bold text-white flex items-center gap-2">
                <span>
                  🕒
                </span>
                {' '}24-Hour Movement Trail Playback
              </h3>
              <p className="text-xs text-slate-400">
                Historical breadcrumb path for:{' '}
                <strong id="history-person-name" className="text-blue-400">
                  Officer Name
                </strong>
              </p>
            </div>
            <button onClick={(event) => { closeModal('history-modal') }} className="text-slate-400 hover:text-white text-2xl font-bold">
              ×
            </button>
          </div>
          {/* Map Container */}
          <div id="history-map" className="w-full h-80 rounded-2xl border border-slate-800 overflow-hidden relative mb-4"></div>
          {/* Timeline Scrubber Bar */}
          <div className="bg-slate-950 p-4 rounded-2xl border border-slate-800 space-y-3">
            <div className="flex items-center justify-between text-xs">
              <span className="font-bold text-slate-400 uppercase tracking-wider">
                Timeline Scrubber (Past 24 Hours):
              </span>
              <span id="history-time-display" className="font-mono text-sm font-black text-blue-400 bg-blue-950/60 px-2.5 py-0.5 rounded border border-blue-800/60">
                --:--
              </span>
            </div>
            <input type="range" id="history-timeline-slider" min="0" max="24" defaultValue="0" step="1" className="w-full accent-blue-500 cursor-pointer" />
            <div className="grid grid-cols-3 gap-2 text-center text-xs pt-1 border-t border-slate-800/80">
              <div>
                <div className="text-[10px] text-slate-500 uppercase font-semibold">
                  Duty Status
                </div>
                <div id="history-status-display" className="font-bold text-emerald-400">
                  AT_STATION
                </div>
              </div>
              <div>
                <div className="text-[10px] text-slate-500 uppercase font-semibold">
                  Speed Recorded
                </div>
                <div id="history-speed-display" className="font-bold text-slate-200 font-mono">
                  0 km/h
                </div>
              </div>
              <div>
                <div className="text-[10px] text-slate-500 uppercase font-semibold">
                  GPS Coordinates
                </div>
                <div id="history-coords-display" className="font-bold text-slate-200 font-mono">
                  --
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* MODAL 5: LOG NEW EMERGENCY / INCIDENT MANUALLY */}
      <div id="new-incident-modal" className="hidden fixed inset-0 z-[99999] bg-black/85 backdrop-blur-md flex items-center justify-center p-4" style={{ zIndex: "99999", display: "none" }}>
        <div className="bg-slate-900 border border-slate-700 rounded-3xl w-full max-w-lg p-6 shadow-2xl text-slate-200 flex flex-col">
          <div className="flex items-center justify-between pb-3 border-b border-slate-800 mb-4">
            <h3 className="text-sm font-black text-white uppercase flex items-center gap-2">
              <span>
                ➕
              </span>
              {' '}Log New Election Incident / Emergency SOS
            </h3>
            <button onClick={(event) => { closeModal('new-incident-modal') }} className="text-slate-400 hover:text-white text-2xl font-bold">
              ×
            </button>
          </div>
          <form id="new-incident-form" onSubmit={(event) => { handleNewIncidentSubmit(event) }} className="space-y-3">
            <div>
              <label className="block text-xs font-semibold text-slate-300 mb-1">
                Select Polling Station / Post:
              </label>
              <select
                id="new-inc-booth-select"
                required
                className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white"
              >
                <option value="">Select Polling Booth</option>

                {booths.map((booth) => (
                  <option key={booth._id} value={booth._id}>
                    {booth.boothId || booth.code} - {booth.name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-xs font-semibold text-slate-300 mb-1">
                Incident Category & Threat Severity:
              </label>
              <select id="new-inc-severity" className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white">
                <option value="CRITICAL">
                  🚨 CRITICAL - Violence, Riot, Armed Threat
                </option>
                <option value="HIGH">
                  ⚠️ HIGH - EVM Glitch, Mob Agitation, Tampering
                </option>
                <option value="MEDIUM">
                  ⚠ MEDIUM - Duty Non-Attendance, Unauthorized Gathering
                </option>
                <option value="LOW">
                  ℹ️ LOW - Queue Congestion, Relief Request
                </option>
              </select>
            </div>
            <div>
              <label className="block text-xs font-semibold text-slate-300 mb-1">
                Incident Description / Report Reason:
              </label>
              <textarea id="new-inc-reason" rows="3" required className="w-full bg-slate-950 border border-slate-700 rounded-xl p-2.5 text-xs text-white" placeholder="Describe situation on ground in detail..." />
            </div>
            <div className="flex items-center justify-end gap-2 pt-2 border-t border-slate-800">
              <button type="button" onClick={(event) => { closeModal('new-incident-modal') }} className="px-4 py-2 bg-slate-800 text-slate-300 hover:text-white rounded-xl text-xs font-bold transition">
                Cancel
              </button>
              <button type="submit" className="px-5 py-2 bg-red-600 hover:bg-red-500 text-white rounded-xl text-xs font-black shadow-lg shadow-red-900/50 transition">
                REGISTER INCIDENT & BROADCAST →
              </button>
            </div>
          </form>
        </div>
      </div>
      <UploadRoster
        open={uploadOpen}
        onClose={() => setUploadOpen(false)}
        defaultTab="OFFICERS"
        tabs={[
          "OFFICERS",
          "SUBDIVISIONS",
          "CIRCLES",
          "STATIONS",
          "BOOTHS",
        ]}
        onUpload={handleRosterUpload}
        onSuccess={() => {
          console.log("Refresh officer list");
        }}
      />
      {/* TOAST CONTAINER */}
      <div id="toast-container" className="fixed bottom-5 right-5 z-50 flex flex-col gap-2 pointer-events-none"></div>
    </>
  );
}

export default EmergencySosMarkup;